import { Routes, Route } from 'react-router-dom';
import WorkshopEquipments from './WorkshopEquipments';
import InventoryTransfer from './InventoryTransfer';

function MobileWorkshop() {

    return(
        <Routes>
            <Route path='/transfer' element={ <InventoryTransfer /> } />
            <Route path='/' element={ <WorkshopEquipments /> } />
        </Routes>
    )
}

export default MobileWorkshop;